
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"19","viewBox":"0 0 11 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0.304694 0.290649C-0.101565 0.678177 -0.101565 1.3065 0.304694 1.69403L8.48836 9.49996L0.304694 17.306C-0.101565 17.6935 -0.101565 18.3218 0.304694 18.7094C0.710954 19.0969 1.36968 19.0969 1.77596 18.7094L10.6953 10.2016C10.8904 10.0156 11 9.76313 11 9.49996C11 9.23681 10.8904 8.9844 10.6953 8.7983L1.77596 0.290649C1.36968 -0.0968831 0.710954 -0.0968831 0.304694 0.290649Z","fill":"white"}})])
          )
        }
      }
    